import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup
} from '@angular/forms';
import { Subscription } from 'rxjs';

import { CheckItem, CheckListFormInput } from '../check-list.model';

@Component({
  selector: 'rpe-check-list-form',
  templateUrl: './check-list-form.component.html',
  styleUrls: ['./check-list-form.component.css']
})
export class CheckListFormComponent implements OnInit, OnDestroy {
  @Input()
  set formInput(formInput: CheckListFormInput) {

    this._formInput = formInput;

    // Se reinicial el formarray
    this.ordersFormArray.clear();
    this.ordersData = formInput.elementosCheck;
    this.addCheckboxes();

  }
  get formInput(): CheckListFormInput {
    return this._formInput;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<CheckItem[]>();

  _formInput: CheckListFormInput = null;
  form: FormGroup;
  ordersData: CheckItem[] = [];
  subscriptions: Subscription[] = [];

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      orders: this.fb.array([], [this.minLengthArray(1)])
    });
  }

  ngOnInit(): void {
    const s1 = this.form.statusChanges.subscribe((f) => {
      this.formStatusChanges.emit(f);
    });
    const s2 = this.form.valueChanges.subscribe((_) => {
      const chekeados: CheckItem[] = this.obtenerSeleccionados();
      this.formValueChanges.emit(chekeados);
    });
    this.subscriptions.push(s1, s2);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  getFormControl = () => {
    return this.form;
  };

  get ordersFormArray() {
    return this.form.controls.orders as FormArray;
  }

  //valida que se elija al menos un elemento
  minLengthArray = (min: number) => {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value.find((r: boolean) => r == true)) return null;
      return { MinLengthArray: true };
    };
  };

  //retorna los checkitem seleccionados
  obtenerSeleccionados = () => {
    const selectedOrder = this.ordersFormArray.controls
      .map((control, i) => (control.value ? this.ordersData[i] : null))
      .filter((v) => v !== null);
    return selectedOrder;
  };

  // arma los datos iniciales del listado
  private addCheckboxes() {
    this.ordersData.forEach((oD) =>
      this.ordersFormArray.push(new FormControl(oD.selected))
    );
    // se emiten las primeras señales con los values y el status
    const checkeados: CheckItem[] = this.obtenerSeleccionados();
    this.formValueChanges.emit(checkeados);
    this.formStatusChanges.emit(this.form.status);
  }

  onShowErrors(): void {
    this.form.markAllAsTouched();
  }
}
